/** PURE_IMPORTS_START _of,_operators_concatAll PURE_IMPORTS_END */
import { of } from './of';
import { concatAll } from '../operators/concatAll';
export function concat() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i] = arguments[_i];
    }
    return concatAll()(of.apply(void 0, observables));
}
//# sourceMappingURL=concat.js.map



//////////////////
// WEBPACK FOOTER
// ./~/rxjs/_esm5/internal/observable/concat.js
// module id = 168
// module chunks = 0